<script>
  export let color = 0; // , -1 -red, 0- gray, 1-yellow, 2-green
  export let size = 15;

  const colors = ['red', '#ddd', 'orange', 'green'];
</script>

<style>
  .main {
    border-radius: 50%;
    border: 1px solid #222;
    display: inline-block;
    vertical-align: middle;
  }
</style>

<div class="main" style={`width:${size}px;height:${size}px; background-color: ${colors[color+1]};`}>

</div>